<script setup lang="ts">

const emit = defineEmits(["offerModalClosed"]);
defineProps({
  collectible: {
    type: Object as PropType<Collectible>,
    required: false,
    default: null,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const { trackEvent } = useGAnalytics();
const route = useRoute();
const isModalOfferMakeShown = ref<boolean>(false);

const handleModalClose = () => {
  isModalOfferMakeShown.value = false;
  emit("offerModalClosed");
};

watch(
  () => route.query.offer,
  (value) => {
    isModalOfferMakeShown.value = true;
  }
);
</script>

<template>
  <div class="flex items-center gap-4 flex-wrap">
    <BaseButtonCancel
      :disabled="disabled"
      data-test="button-offer"
      class="w-72"
      @click="
        (isModalOfferMakeShown = true),
          trackEvent(`make_offer_collectible_page`)
      "
      :contextual-styles="true">
      <template #text>
        {{ $t("main.collectibleDetail.makeOffer") }}
      </template>
      <template #image-suffix>
        <BaseIcon
          name="tag"
          class="w-4 h-4 merchant-cta-icon--cancel text-primary-100" />
      </template>
    </BaseButtonCancel>
  </div>
  <ModalOfferMake
    v-if="isModalOfferMakeShown"
    :collectible="collectible"
    @close="handleModalClose" />
</template>
